export const delegatedPermissionPartials = {
  title: 'Calendar Access Required',
  description: "We don't have permission to access your calendar. If you want to create a reservation from Tactic, you need to grant us permission.",
  buttonText: 'Connect Outlook',
};

export default delegatedPermissionPartials; 